import React from 'react';
import { styled, Switch } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import { selectCBFriendly } from '../../../store/ui/ui.selector';
import { changeCbFriendly } from '../../../store/ui/ui.slice';

import './cbf-toggle.styles.scss';

const CustomSwitch = styled(Switch)(() => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1890ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export default function CbfToggle() {
  const dispatch = useDispatch();
  const cbFriendly = useSelector(selectCBFriendly);

  const handleToggle = (e) => {
    dispatch(changeCbFriendly(e.target.checked));
  };

  return (
    <div className='cbf-toggle-container'>
      <div className='cbf-toggle-text'>
        Use alternate precipitation coloring
      </div>
      <CustomSwitch
        color='primary'
        size='small'
        checked={cbFriendly}
        onChange={handleToggle}
      />
    </div>
  );
}
